var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import SelectFilter from "./SelectFilter";
import FormGroup from "../../DocumentForm/components/FormGroup";

import { NeedAuthorization } from "../../Auth";
import { Translate } from "../../I18N";
import { Icon } from "../../UI";






const filteredAggregation = (aggregations, key) => {var _aggregations$all, _aggregations$all$_pu;return (
    (
    ((aggregations === null || aggregations === void 0 ? void 0 : (_aggregations$all = aggregations.all) === null || _aggregations$all === void 0 ? void 0 : (_aggregations$all$_pu = _aggregations$all._published) === null || _aggregations$all$_pu === void 0 ? void 0 : _aggregations$all$_pu.buckets) || []).find((a) => a.key === key) || {
      filtered: { doc_count: 0 }
    }).
    filtered.doc_count || 0);};

const generateOptions = (aggregations) => [
{
  label: /*#__PURE__*/
  React.createElement(React.Fragment, null, /*#__PURE__*/
  _jsx(Icon, { icon: "globe-africa" }), "\xA0", /*#__PURE__*/

  _jsx(Translate, {}, void 0, "Published")
  ),

  title: 'Published',
  value: 'published',
  results: filteredAggregation(aggregations, 'true')
},
{
  label: /*#__PURE__*/
  React.createElement(React.Fragment, null, /*#__PURE__*/
  _jsx(Icon, { icon: "lock" }), "\xA0", /*#__PURE__*/

  _jsx(Translate, {}, void 0, "Restricted")
  ),

  title: 'Restricted',
  value: 'restricted',
  results: filteredAggregation(aggregations, 'false')
}];


const PublishedFilters = ({ onChange, aggregations }) => {
  const options = generateOptions(aggregations);
  const totalAggs = options.reduce((total, o) => total + o.results, 0);
  if (totalAggs === 0) {
    return null;
  }
  return /*#__PURE__*/(
    _jsx(NeedAuthorization, { roles: ['admin', 'editor', 'collaborator'] }, void 0, /*#__PURE__*/
    _jsx(FormGroup, { className: "admin-filter" }, "publishedStatus", /*#__PURE__*/
    _jsx(SelectFilter, {
      model: ".publishedStatus",
      prefix: "publishedStatus",
      onChange: onChange,
      options: options,
      showBoolSwitch: false }
    )
    )
    ));

};


export { PublishedFilters };